
<div #reportContainer style="height: 600px; margin: 0px auto; overflow-y: auto; background-color: white; font-family: '細明體';">
</div>